import { Injectable, OnDestroy } from '@angular/core';
import { AccountService } from 'src/app/account/services/account.service';
import { AppSide, StorageKeyNamesCommon, StorageKeyNamesManage } from 'src/app/constants';
import { ManagementService } from 'src/app/management/services/management.service';
import { jwtDecode } from "jwt-decode";
import { environment } from 'src/environments/environment';
import { takeWhile } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService implements OnDestroy {

  manageUserData: any;

  storeUserData: any;

  environment = environment;

  destroySubscription = false;

  constructor(private managementService: ManagementService, private accountService: AccountService) {
    this.manageUserData = this.managementService.getMngToken();
    this.storeUserData = this.accountService.getUser();
    this.managementService.removeAllManageGridParams.pipe(takeWhile(() => !this.destroySubscription)).subscribe({
      next: (response: any) => {
        this.removeAllManageGridParams(AppSide.manageSide);
      }
    });
    this.accountService.removeAllStoreGridParams.pipe(takeWhile(() => !this.destroySubscription)).subscribe({
      next: (response: any) => {
        this.removeAllStoreGridParams(AppSide.storeSide);
      }
    });
  }

  generateStorageKey(fromSide: string, storageKeyName: string, fromComponentUniqueName: string,) {
    // console.log('manageUserData', this.manageUserData);
    let key = '';
    let manageUniqueKey = '';
    let storeUniqueKey = '';
    let env = environment.envIndicator ? 'dev' : 'pr';
    if (fromSide === AppSide.manageSide && this.manageUserData && this.manageUserData.access_token) {
      const decoded = jwtDecode(this.manageUserData.access_token);
      manageUniqueKey = decoded.sub ? decoded.sub : '';
    } else if (fromSide === AppSide.storeSide && this.storeUserData) {
      // console.log('storeuser data', this.storeUserData);
      storeUniqueKey = this.storeUserData.user_id;
    }

    if (fromSide === AppSide.manageSide && manageUniqueKey) {
      key = AppSide.manageSide + '_' + env + '_' + storageKeyName + '_' + manageUniqueKey + '_' + fromComponentUniqueName;
    } else if (fromSide === AppSide.storeSide && storeUniqueKey) {
      key = AppSide.storeSide + '_' + env + '_' + storageKeyName + '_' + storeUniqueKey + '_' + fromComponentUniqueName;
    }
    return key;
  }

  saveGridParams(urlParams: any, fromSide: string, fromComponentUniqueName: string, storageKeyName: string) {
    // console.log('urlparams at save', urlParams);
    let key = this.generateStorageKey(fromSide, storageKeyName, fromComponentUniqueName);
    // console.log('key', key);
    window.localStorage.removeItem(key);
    if (key) {
      window.localStorage.setItem(key, JSON.stringify(urlParams));
    }
  }

  getGridParams(fromSide: string, fromComponentUniqueName: string, storageKeyName: string) {
    let key = this.generateStorageKey(fromSide, storageKeyName, fromComponentUniqueName);
    const gridParams = window.localStorage.getItem(key);
    if (gridParams && gridParams !== 'undefined') {
      return JSON.parse(gridParams);
    }
    return null;
  }

  removeGridParams(fromSide: string, fromComponentUniqueName: string, storageKeyName: string) {
    let key = this.generateStorageKey(fromSide, storageKeyName, fromComponentUniqueName);
    window.localStorage.removeItem(key);
  }

  // remove manage side localStorage grid params
  // first it will remove common grid parmas which are common to store side
  // then remove manage side grid parmas with generating key without component name
  // as we are dynamically removing all manage side localStorage grid params at logout 
  // we dont have component name for any storage
  // call function removeLocalStorageStartWithKey
  removeAllManageGridParams(fromSide: string) {
    this.removeCommonGridParams(fromSide);
    if (StorageKeyNamesManage && Object.keys(StorageKeyNamesManage).length) {
      for (const [key, value] of Object.entries(StorageKeyNamesManage)) {
        console.log(`${key}: ${value}`);
        if (Object.keys(localStorage).length) {
          this.removeLocalStorageStartWithKey(fromSide, `${value}`);
        }
      }
    }
  }

  // remove store side localStorage grid params
  // first it will remove common grid parmas which are common to manage side
  // then remove storage side grid parmas with generating key without component name
  // as we are dynamically removing all store side localStorage grid params at logout 
  // we dont have component name for any storage
  // call function removeLocalStorageStartWithKey
  removeAllStoreGridParams(fromSide: string) {
    this.removeCommonGridParams(fromSide);
  }

  removeCommonGridParams(fromSide: string) {
    if (StorageKeyNamesCommon && Object.keys(StorageKeyNamesCommon).length) {
      for (const [key, value] of Object.entries(StorageKeyNamesCommon)) {
        // console.log(`${key}: ${value}`);
        if (Object.keys(localStorage).length) {
          this.removeLocalStorageStartWithKey(fromSide, `${value}`);
        }
      }
    }
  }

  // as we dont know component names to generate localstorage key
  // we match the start value of the key using
  // fromSide + env +  storageKeyName + manageUniqueKey OR
  // fromSide + env +  storageKeyName + storageUniqueKey
  // and delete that item
  removeLocalStorageStartWithKey(fromSide: string, storageKeyName: string) {
    const tempKey = this.generateStorageKey(fromSide, storageKeyName, '');
    console.log('tempKey', tempKey);
    for (const [localStorageKey, localStorageValue] of Object.entries(localStorage)) {
      // console.log(localStorageKey, localStorageValue);
      let keyName = localStorageKey;
      console.log('keyName', keyName);
      console.log('keyName.startsWith(tempKey)', keyName.startsWith(tempKey));
      if (tempKey && keyName && keyName.startsWith(tempKey)) {
        console.log('match');
        window.localStorage.removeItem(keyName);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }
}
